import { ActionTypeList } from '../../constants'

const initialState = false;

export const targetDetailPageModePayload = (state = initialState, action) => {

    switch (action.type) {
        case ActionTypeList.TARGET_SETTING_DETAIL_PAGE_MODE_UPDATED:
            return action.payload;
        default:
            return state;
    }
}

export const accountTargetDetailPageModePayload = (state = initialState, action) => {

    switch (action.type) {
        case ActionTypeList.ACCOUNT_TARGET_SETTING_DETAIL_PAGE_MODE_UPDATED:
            return action.payload;
        default:
            return state;
    }
}